<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-4">
                            <select2 name="Servisler"
                                     :data="services"
                                     :selected="filters.service"
                                     :maxSelection="1"
                                     :minSelection="1"
                                     v-on:onChange="onServiceFilterChanged" />
                        </div>
                        <div class="col-md-5"></div>
                        <div class="col-md-3">
                            <select2 name="Bildirim Türü"
                                     :data="eventTypes"
                                     :selected="filters.eventType"
                                     :minSelection="1"
                                     :maxSelection="1"
                                     v-on:onChange="onEventTypeFilterChanged" />
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-body">
                    <chart2 :xAxesSettings="xAxesSettings" :tableData="data" :labelColumn="labelColumn" :dataColumns="dataColumns" :hasTotalRow="false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import parallel from 'async/parallel';
    import Select2 from '../../../components/select.v2.vue';
    import $ from 'jquery';
    import AutoUpdate from '../../../components/auto_update.vue';
    import Table2 from '../../../components/table.v2.vue';
    import Chart2 from '../../../components/chart.v2.vue';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'autoupdate': AutoUpdate,
            'table2': Table2,
            'chart2': Chart2
        },
        data: function () {
            return {
                filters: {
                    service: [],
                    eventType: ['app_sale']
                },
                eventTypes: [
                    {
                        id: 'app_sale',
                        text: 'app_sale'
                    },
                    {
                        id: 'app_verification',
                        text: 'app_verification'
                    },
                    {
                        id: 'app_view',
                        text: 'app_view'
                    },
                    {
                        id: 'call_record',
                        text: 'call_record'
                    },
                    {
                        id: 'charging',
                        text: 'charging'
                    },
                    {
                        id: 'getcontact_call_history',
                        text: 'getcontact_call_history'
                    },
                    {
                        id: 'getcontact_contact_counter',
                        text: 'getcontact_contact_counter'
                    },
                    {
                        id: 'getcontact_phone_book_counter',
                        text: 'getcontact_phone_book_counter'
                    },
                    {
                        id: 'getcontact_search',
                        text: 'getcontact_search'
                    },
                    {
                        id: 'getcontact_spam',
                        text: 'getcontact_spam'
                    },
                    {
                        id: 'push_notification',
                        text: 'push_notification'
                    },
                    {
                        id: 'service_page_view',
                        text: 'service_page_view'
                    },
                    {
                        id: 'service_refund',
                        text: 'service_refund'
                    },
                    {
                        id: 'subs_end',
                        text: 'subs_end'
                    },
                    {
                        id: 'subs_job_amount',
                        text: 'subs_job_amount'
                    },
                    {
                        id: 'subs_rest',
                        text: 'subs_rest'
                    },
                    {
                        id: 'subs_start',
                        text: 'subs_start'
                    },
                    {
                        id: 'translate_character_count',
                        text: 'translate_character_count'
                    }
                ],
                services: [],
                data: [],
                dataColumns: {
                    total: 'Bildirim Sayısı'
                },
                labelColumn: 'date',
                xAxesSettings: [{
                    type: 'time',
                    time: {
                        unit: 'minute',
                        displayFormats: {
                            minute: 'MMM YYYY h:mm'
                        },
                        distribution: 'series'
                    }
                }],
                loading: false,
                reportDataLoading: false
            }
        },
        mounted: function () {
            var $this = this;
            this.loading = true;
            parallel([
                function (next) {
                    var params = {
                        dashboard_id: $this.$router.currentRoute.query.id
                    };
                    $this.$app.get('/api/v1/users/' + $this.$app.getUser().id + '/services', params, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.services = $.map(response.services, function (service) {
                            return {
                                id: service.id,
                                text: service.name
                            }
                        });
                        var savedService = $this.$app.getValue('metric.service.v2');
                        if (savedService !== null) {
                            $this.filters.service = savedService;
                        } else {
                            $this.filters.service = [$this.services[0].id];
                        }
                        next();
                    });
                }
            ], function (err, results) {
                $this.loading = false;
                $this.loadData();
            });
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    service_id: this.filters.service,
                    event_type: this.filters.eventType
                };
                this.$app.get('/api/v1/dashboards/report/metric/event-tps-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                }, {'Timezone': this.$app.getTimezone()});
            },
            onServiceFilterChanged: function (data) {
                this.filters.service = data;
                this.$app.setValue('metric.service.v2', data);
                this.loadData();
            },
            onEventTypeFilterChanged: function (data) {
                this.filters.eventType = data;
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: 11px;
    }
</style>


// WEBPACK FOOTER //
// event_tps.vue?92b79b94